import AppSettings from "../../../../Settings/AppSettings";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import React, { useState, useContext } from "react";
import LoadingSuccessErrorAlert from "../../Rules/Components/LoadingSuccessErrorAlert";
import { toast } from "Components/DesignSystem/Toast/useToast";
import { AppContext } from "../../../../Context/AppContext";
import PdwUploadDropzone from "./PdwUploadDropzone";

/**
 * PDW "Product Creation File" upload. On the design system since § 126 — the markup
 * moved into `PdwUploadDropzone`, every handler below stayed exactly where it was.
 */
const Create = ({
  modalCreateClose,
  load_Products_By_Category,
  fromProduct = false,
  instanceId = "pdw-create",
}) => {
  const appData = useContext(AppContext);
  const channelKey = appData?.channelKey;
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const suppressRule = false;
  let [selectedFile, setSelectedFile] = React.useState(null);

  // delete selected file
  async function handleFileDelete(event) {
    event.preventDefault();
    if (selectedFile != null) setSelectedFile(null);
  }
  async function handle_file_selection(event) {
    event.preventDefault();
    const file = event.target.files[0];
    const totalCount = await appData.checkSelectedFile(file, file.type);
    if (totalCount > 0) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  }

  async function do_upload_pdw() {
    setLoading({
      status: "Loading",
      message: "File uploading....",
    });
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("supress_rule", suppressRule);

    let res = await ServiceWrapper.doPost(
      api_base_url + `pdw/upload/createproducts/${channelKey}`,
      formData,
      null,
      AuthManager.getGmsToken(),
      true
    );

    if (!res.errorfound) {
      if (res.data.done === true) {
        setLoading({
          status: "Loading",
          message: res.data.message,
        });
        functionThatResetsTheFileInput();
        setSelectedFile(null);
        setTimeout(() => {
          checkUploadStatus(res.data.jobid);
        }, 2000);
      } else {
        toast.error(res.data.message);
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      toast.error("Error while uploading a file...");
      setLoading({
        status: "Error",
        message: "Error Uploading file",
      });
    }
    functionThatResetsTheFileInput();
    setSelectedFile(null);
  }

  async function checkUploadStatus(jobId) {
    if (jobId) {
      let ret = await ServiceWrapper.doGet(
        api_base_url + "job/status/" + jobId,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (!ret.errorfound) {
        if (ret.data.processing) {
          setLoading({
            status: "Loading",
            message: ret.data.status,
          });
          setTimeout(() => {
            checkUploadStatus(jobId);
          }, 2000);
          return;
        }

        if (ret.data.error) {
          toast.error(ret.data.status);
          setLoading({
            status: "Error",
            message: ret.data.status,
          });
          return;
        }
        toast.success(ret.data.status);

        setLoading({
          status: "",
          message: "",
        });
        if (fromProduct) {
          load_Products_By_Category();
        }
        modalCreateClose();
      }
    } else {
      toast.error("Job Id not found");
      setLoading({
        status: "Error",
        message: "JobId not found",
      });
    }
  }

  const [inputKey, setInputKey] = useState("");
  const functionThatResetsTheFileInput = () => {
    let randomString = Math.random().toString(36);
    setInputKey(randomString);
  };

  return (
    <div>
      <PdwUploadDropzone
        inputId={`${instanceId}-file`}
        inputTestId="upload-create-input-1"
        inputKey={inputKey}
        onFileSelect={(event) => handle_file_selection(event)}
        selectedFile={selectedFile}
        onDelete={handleFileDelete}
        onCancel={() => modalCreateClose()}
        onSave={() => do_upload_pdw()}
        cancelLabel="Close"
        cancelTestId="pdw-create-close-btn"
        saveTestId="pdw-create-save-btn"
        deleteTestId="pdw-create-delete-btn"
        /* Create alone also blocks Save while a job is in flight. Update and
           Validate do not — a real asymmetry between the three, recorded in
           `okf/pdw/e2e.md` § 7.1 and deliberately left alone here. */
        saveDisabled={!selectedFile || Loading?.status === "Loading"}
      />

      <div className="tw-mt-4">
        <LoadingSuccessErrorAlert loading={Loading} hide_error={true} />
      </div>
    </div>
  );
};
export default Create;